import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

import { CoreConfigService } from '@core/services/config.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-auth-reset-password-page',
  templateUrl: './auth-reset-password-page.component.html',
  styleUrls: ['./auth-reset-password-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthResetPasswordPageComponent implements OnInit {
  // Public
  public coreConfig: any;
  public passwordTextType: boolean;
  public confPasswordTextType: boolean;
  public resetPasswordForm: FormGroup;
  public submitted = false;

  private _unsubscribeAll: Subject<any>;

  token:any;
  id: any;
  email: any;
  
  constructor(private _coreConfigService: CoreConfigService, 
    private _formBuilder: FormBuilder,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService) {
    
 
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.resetPasswordForm.controls;
  }

    togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
   * Toggle confirm password
   */
  toggleConfPasswordTextType() {
    this.confPasswordTextType = !this.confPasswordTextType;
  }

  /**
   * On Submit
   */


  onSubmit() {
    this.submitted = true;
 
    // stop here if form is invalid
    if (this.resetPasswordForm.invalid) {
      return;
    }
 
    // Login
    //this.loading = true;
    console.log(this.resetPasswordForm.controls['newPassword'].value);
    const pass = this.resetPasswordForm.controls['newPassword'].value
 
    this.resetPassword(pass);
    
    // redirect to home page
    //setTimeout(() => {
    //  this._router.navigate(['/dashboard/folders']);
   // }, 100);
 
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params.id;
    this.token = this.activatedRoute.snapshot.params.token;

    this.resetPasswordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    });

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  resetPassword(pass){
          this.token = this.activatedRoute.snapshot.params.token;
          this.email = this.activatedRoute.snapshot.params.email;
          this.authService.resetPassword(this.email, this.resetPasswordForm.controls['newPassword'].value).subscribe(
            (res: any) => {
              console.log(res)
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Contraseña actualizada',
                text: 'La contraseña fue actualizada correctamente',
                showConfirmButton: false,
                timer: 1000
              })
                  this._router.navigate(['']);
            }
          )
  }
  
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
